'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _uuid = require('uuid');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/**
 * @description :: Class that deals with blocking the scroll when a modal is open
 * @class WindowScrollBlocker
 */


var WindowScrollBlocker = function () {
  function WindowScrollBlocker() {
    _classCallCheck(this, WindowScrollBlocker);

    this.holders = [];
  }

  _createClass(WindowScrollBlocker, [{
    key: 'add',

    /**
     * @description :: Adding an indicator that something is blocking the scroll
     * @param {String} holder :: The id of the holder
     * @return {Function} :: returning this remove() function to easaly clear the blocking scroll
     * @memberof WindowScrollBlocker
     */
    value: function add() {
      var holder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var id = holder || (0, _uuid.v4)();
      this.holders = [].concat(_toConsumableArray(this.holders), [id]);
      this.hold();
      return this.remove.bind(this, id);
    }
    /**
     * @description :: Clearing the element that should block the scroll
     * @param {String} holder :: An identifier to identify the element that was blocking the scroll
     * @memberof WindowScrollBlocker
     */

  }, {
    key: 'remove',
    value: function remove(holder) {
      this.holders = [].concat(_toConsumableArray(this.holders)).filter(function (hold) {
        return hold !== holder;
      });
      this.hold();
    }
    /**
     * @description :: Function that determinates if window shoul be scrollable or not
     * @memberof WindowScrollBlocker
     */

  }, {
    key: 'hold',
    value: function hold() {
      var html = (0, _jquery2.default)('html');

      if (this.holders.length && html.css('overflow') !== 'hidden') {
        html.css('overflow', 'hidden');
      } else if (!this.holders.length && html.css('overflow') === 'hidden') {
        html.css('overflow', '');
      }
    }
  }]);

  return WindowScrollBlocker;
}();

exports.default = new WindowScrollBlocker();